// components/ProjectImage.jsx
const IMAGEKIT_ENDPOINT = "https://ik.imagekit.io/wwg4nuz3a";

const ImageKit = ({ path, alt, className, ratio = "16/9" }) => {
  const widths = [400, 800, 1200, 1920, 2560, 3840];

  // Helper to build ImageKit URL with dynamic width and aspect ratio
  const getIkUrl = (path, w) => {
    // We convert "16/9" to "16-9" for ImageKit's URL syntax
    const ikRatio = ratio.replace("/", "-");
    return `${IMAGEKIT_ENDPOINT}/${path}?tr=w-${w},ar=${ikRatio},fo-auto `;
  };

  const srcSet = widths
    .map((w) => `${getIkUrl(path, w)} ${w}w`)
    .join(", ");

  return (
    <img
      src={getIkUrl(path, 1920)} // Default fallback
      srcSet={srcSet}
      // "sizes" tells the browser: "On mobile this is full width, 
      // on desktop it's roughly half the screen."
      sizes="100vw"
      alt={alt}
      loading="lazy"
      className={className}
      style={{
        width: "100%",
        display: "block",
        maxHeight: ratio === "9/16" ? "60vh" : "100vh",  // Prevents vertical images from being taller than the screen
        // Fix #1 (best): Control size via ImageKit URL
      }}
    />
  );
};

export default ImageKit;